import { createContext, useContext } from "react";

// Who is signed in, asked once per load by AuthProvider (App.js): { phase: checking | ok | no, user, setUser }.
export const AuthContext = createContext({ phase: "checking", user: null, setUser: () => {} });
export const useAuth = () => useContext(AuthContext);

// The signed-in person, provided by the route guards beneath AuthProvider. { id, email, name, role, status, prefs, setUser }
export const UserContext = createContext(null);
export const useUser = () => useContext(UserContext);
export const isAdmin = (u) => u?.role === "admin";
// The admin-password session: role admin, but no account, so no meetings, briefings or account page.
export const isPasswordAdmin = (u) => !!u?.is_admin_password;

// Setup links carry a signed token; the page that opens them is /welcome.
export const setupLink = (token) => `${window.location.origin}/welcome?token=${encodeURIComponent(token)}`;
